import uikitStyles from 'uikit/dist/css/uikit.css';

export default uikitStyles;



// WEBPACK FOOTER //
// ./src/utils/uikitStyles.js